<script>
  import {createEventDispatcher} from 'svelte';
  import {db} from './firebase.js'

  export let cboFields;
  export let serviceTagsList;

  let dispatch = createEventDispatcher();
  // let fields = {id: '', rogram: '', url: '', description: '', address: '', zipcode: '', service_tags: '', attribute_tags: ''};

  // let arr = [];
// cboFields.service_tags = [];

  const handleSubmit = () => {
    let data = {...cboFields};
    // console.log(data);
    let cboDB = {};
      // id: data.id,
    if (data.program){cboDB.program = data.program;};
    if (data.description) {cboDB.description = data.description;};
    if (data.url) {cboDB.url = data.url;}
    if (data.address) {cboDB.address = data.address;};
    if (data.zipcode) {cboDB.zipcode = data.zipcode;};
    // if (data.service_tags) {cboDB.service_tags = data.service_tags;};
    if (data.service_tags) {
      cboDB.service_tags = data.service_tags;
    };
    if (data.attribute_tags) {cboDB.attribute_tags = data.attribute_tags;};

    db.collection('cbos').doc(data.id).set(cboDB);
    // console.log(cboFields);
    // console.log(cboDB);
    dispatch('add', data);
  }
</script>

<form on:submit|preventDefault={handleSubmit}>
  <input type="hidden" bind:value={cboFields.id}>
  <div class="field">
    <label class="label">Program</label>
    <div class="control">
      <input type="text" class="input" placeholder="program" bind:value={cboFields.program}>
    </div>
  </div>
  <div class="field">
    <label class="label">Description</label>
    <div class="control">
      <textarea class="textarea" placeholder="description" bind:value={cboFields.description}></textarea>
    </div>
  </div>
  <div class="field">
    <label class="label">Address</label>
    <div class="control">
      <input type="text" class="input" placeholder="address" bind:value={cboFields.address}>
    </div>
  </div>
  <div class="field">
    <label class="label">Zipcode</label>
    <div class="control">
      <input type="text" class="input" placeholder="zipcode" bind:value={cboFields.zipcode}>
    </div>
  </div>
  <div class="field">
    <label class="label">URL</label>
    <div class="control">
      <input type="text" class="input" placeholder="url" bind:value={cboFields.url}>
    </div>
  </div>

  <!-- <div class="field">
    <label class="label">Service tags</label>
    <div class="control">
      <input type="text" class="input" placeholder="service tags" bind:value={cboFields.service_tags}>
    </div>
  </div> -->
  <div class="field">
    <label class="label">Attribute tags</label>
    <div class="control">
      <input type="text" class="input" placeholder="attribute tags" bind:value={cboFields.attribute_tags}>
    </div>
  </div>
  <label class="label">Service tags</label>
  {#if cboFields.service_tags}
    {#each serviceTagsList as stag}
    	<label class="chk">
    		<input type=checkbox bind:group={cboFields.service_tags} value={stag}>
    		{stag}
    	</label>
    {/each}
  {/if}



  <!-- serviceTagsList -->
  <div class="field btn">
    <div class="control">
      <button class="button is-link">Update</button>
    </div>
  </div>
</form>

<style>
  .field.btn{
    margin-top: 15px;
  }
  label.chk{
    padding-left:10px;
        line-height: 25px;
  }
</style>
